import {env} from "../constants";

const ALLOWED_ENVS = ["local", "staging"];

export const isDevToolsEnabled = () => {
  return ALLOWED_ENVS.includes(env);
};
